module.exports = __webpack_public_path__ + "img/airline_seat_flat.5de98dfa.svg";